import React, {useEffect} from 'react';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import PageTitleCard from '../../CommonComponents/PageTitleCard';
import PageHeading from '../../CommonComponents/PageHeading';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import VendorShowSponsor from './StaticCard';
import CommonInfoCard from '../../CommonComponents/CommonPolicyCard';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import {Col, Row} from 'antd';
import useLocalization from '../../../Localization';

const VendorShowComponent = () => {
  const {ApplicationString} = useLocalization();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);
  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRow'>
        <Col span={24}>
          <SponsorOptionPageHeroText
            title={ApplicationString['userVendorShowComponent.heading']}
            subTitle={ApplicationString['userVendorShowComponent.subheading']}
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <CommonInfoCard
              content={<VendorShowSponsor />}
              title={'Vendor Show Sponsor'}
              imgSrc={
                'https://images.unsplash.com/photo-1558008258-3256797b43f3?auto=format&fit=crop&q=80&w=1931&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
              }
            />
            <CustomCollapse />
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default VendorShowComponent;
